import COLOR_TYPES from "../colors/type";

const predictColor = (red, blue, green, yellow) => {
  if (blue > red && blue > green && blue > yellow) {
    return COLOR_TYPES.BLUE;
  }
  if (red > blue && red > green && red > yellow) {
    return COLOR_TYPES.RED;
  }
  if (green > red && green > blue && green > yellow) {
    return COLOR_TYPES.GREEN;
  }
  if (yellow > red && yellow > green && yellow > blue) {
    return COLOR_TYPES.YELLOW;
  }

  // RED EQUAL
  if (red === blue && red > yellow && red > green) {
    //RED_BLUE
    return COLOR_TYPES.RED;
  }

  if (red === yellow && red > blue && red > green) {
    //RED_YELLOW
    return COLOR_TYPES.RED;
  }

  if (red === green && red > yellow && red > blue) {
    //RED_GREEN
    return COLOR_TYPES.RED;
  }

  // BLUE EQUAL
  if (blue === green && blue > yellow && blue > red) {
    //BLUE_GREEN
    return COLOR_TYPES.BLUE;
  }

  if (blue === yellow && blue > green && blue > red) {
    //RED_YELLOW
    return COLOR_TYPES.RED;
  }

  // YELLOW EQUAL
  if (yellow === green && yellow > blue && yellow > red) {
    // GREEN_YELLOW
    return COLOR_TYPES.GREEN;
  }
};

export default predictColor;
